import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealLaScSection } from "@/types/dealLaSc.types";
import { DealFilingSection, DealsSection } from "@/types/deals.types";

export const CHECK_DEAL_TABLE_KEY_BY_GROUP_TABLE_KEY: {
  Deals: {
    [key in DealsSection]: string | null;
  };
} = {
  Deals: {
    "Drug Profile": "Drug",
    "Deal Type & Status": null,
    "Licensee Table": "Licensee",
    "Licensor Table": null,
    "Additional Information (Deal)": null,
    "Key Comment": null,
    "Key Comment List": null,
    "Key Comment Set Option List": null,
    "Advisor Table": null,
    "Deal Structure": null,
  },
};

export const CHECK_DEAL_FILING_TABLE_KEY_BY_GROUP_TABLE_KEY: {
  "Deal Filing": {
    [key in DealFilingSection]: string | null;
  };
} = {
  "Deal Filing": {
    "Drug Profile": "Drug",
    "Deal Type & Status": null,
    "Licensee Table": "Licensee",
    "Licensor Table": null,
    "Additional Information (Deal)": null,
    "Key Comment": null,
  },
};
export const CHECK_DEAL_LA_SC_TABLE_KEY_BY_GROUP_TABLE_KEY: {
  "Deal LA&SC": {
    [key in DealLaScSection]: string | null;
  };
} = {
  [ENTRY_DATA_SECTION_KEYS.dealsLaSc]: {
    "Drug Profile": "Drug",
    "Main Financial Terms Table": "Financial Terms",
    "Deal Purpose": null,
    "Additional Information": null,
    "Other Financial Terms": null,
    "Advisor Table": null,
    "Key Comment": null,
    "Deal Terms & Additional Information": null,
    "Rights Scope Table": null,
    "Partner Axis": null,
  },
};
